export const AGORA_APP_ID = 'bb7f1b6f501b48acb4d47b43226e53ce' // set your app id here
